import React from 'react';
import PropTypes from 'prop-types';
import css from './KeyAreaBox.module.scss';

const KeyAreaBox = ({
  icon,
  label,
  counts,
  onClick,
  onSeverityBadgeClick,
  categoryValue,
}) => {
  const countItems = [
    {type: 'HIGH', value: counts?.HIGH ?? 0},
    {type: 'MEDIUM', value: counts?.MEDIUM ?? 0},
    {type: 'LOW', value: counts?.LOW ?? 0},
  ];
  const allZero = countItems.every(item => item.value === 0);
  const items = allZero ? [{type: 'neutral', value: 0}] : countItems;
  const reversedItems = [...items].reverse();

  return (
    <div className={css.keyAreaItem} onClick={onClick}>
      <span className={css.icon}>{icon}</span>
      <span className={css.label}>{label}</span>
      <div className={css.counts}>
        {reversedItems.map((item, index) =>
          <span
            key={`${label}-${item.type}`}
            className={`${css.count} ${css[item.type]}`}
            onClick={item.value !== 0 && onSeverityBadgeClick
              ? event => {
                event.stopPropagation();
                onSeverityBadgeClick(item.type, categoryValue);
              }
              : undefined}
            style={{
              right: `${index * 20}px`,
              zIndex: index,
            }}
          >
            {item.value}
          </span>
        )}
      </div>
    </div>
  );
};

KeyAreaBox.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string.isRequired,
  counts: PropTypes.shape({
    HIGH: PropTypes.number,
    MEDIUM: PropTypes.number,
    LOW: PropTypes.number,
  }),
  onClick: PropTypes.func,
  onSeverityBadgeClick: PropTypes.func,
  categoryValue: PropTypes.string,
};

export default KeyAreaBox;
